import { loaderAction, setChangeUserEmailFormAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";
import { CHANGE_USER_EMAIL_FORM_INITIAL } from "../initialStateConstant";

export const ChangeUserEmailThunk = (args) => async (dispatch, getState) => {
    const { user, currentUser } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('user', currentUser.id);
        formData.append('email', args.email);

        const response = await api({ data: formData, link: 'change_user_email' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем форму редактирования почты
            dispatch(setChangeUserEmailFormAction(CHANGE_USER_EMAIL_FORM_INITIAL));

            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        dispatch(loaderAction(false));
    }
};